import DeleteStage from './DeleteStage';
import './DeleteStage.scss';

export default DeleteStage;
